let policyIndex = null;

// Chunks already have embeddings attached by bootstrapPolicies — just store them.
export const buildPolicyIndex = (chunks) => {
  policyIndex = chunks;
};

export const getPolicyIndex = () => policyIndex;
